import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  CustomAccordion,
  CustomTabs,
  Text,
} from "../../../shared/uiComponents";
import { useCheckPermission, useScreenWidth } from "../../../shared/Helpers/hooks";
import { Container } from "../../../components/StyledComponents";
import CredentialedBCBA from "./credentialedBCBA";
import NotCredentialedBCBA from "./notCredentialedBCBA";
import DefaultBCBA from "./defaultBCBA";
import BT from "./BT";
import SaveChanges from "./saveChanges";
import { PERMISSIONS } from "../../../App/constants";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getClient } from "../../../redux/State/clientSlice/clientSlice";
import { getTherapists } from "../../../redux/State/clientSlice/userClientSlice";

const Assign = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const screenWidth = useScreenWidth();
  const { clientId } = useParams();

  const ASSIGN_BCBA = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_BCBA);
  const ASSIGN_RBT = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_RBT);

  const therapists = useSelector((state) => state.userClient.therapists);
  const clientInfo = useSelector((state) => state.client.client);

  useEffect(() => {
    if (!!therapists || !clientId) return;
    dispatch(getTherapists({ clientId }));
  }, [clientId, therapists, dispatch]);

  useEffect(() => {
    if (!clientId) return;
    if (!!clientInfo.fullName) return;
    dispatch(getClient(clientId));
  }, [clientId, clientInfo, dispatch]);

  const headers = [
    { id: 0, name: `BCBA - credentialed`, isAllowed: ASSIGN_BCBA.permissionGranted, panel: CredentialedBCBA },
    { id: 1, name: `BCBA - not credentialed`, isAllowed: ASSIGN_BCBA.permissionGranted, panel: NotCredentialedBCBA },
    { id: 2, name: `BT`, isAllowed: ASSIGN_RBT.permissionGranted, panel: BT }];

  const tabHeaders = headers.filter(x => x.isAllowed).map(x => x.name);
  const tabPanels = headers.filter(x => x.isAllowed).map(x => x.panel);

  return (
    <Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
        className="marginBottom16"
      >
        <Text
          title={`Assign Providers for ${clientInfo.fullName}`}
          size="largeBold"
        />
        <DefaultBCBA />
      </div>
      {screenWidth > 768 ? (
        <CustomTabs headers={tabHeaders} panels={tabPanels} />
      ) : (
        headers.filter(x => x.isAllowed)
          .map((header, index) => (
            <CustomAccordion
              key={index}
              HeaderContent={() => <Text title={header.name} size="smallBold" />}
              Content={header.panel}
            />
          ))
      )}
      <SaveChanges />
    </Container>
  );
};

export default Assign;
